<template>
  <div class="h-auto bg-white m-3 p-2 rounded-md relative">
    <create-disciplinary-record
    :showCreateDisciplinary = "showCreateDisciplinary"
    @close="showCreateDisciplinary = false"
    @record-created="getMyDisciplinaryRecord"
    ></create-disciplinary-record>
    <div class="bg-white rounded-md p-1">
      <div class="flex justify-between items-center py-3">
        <p class="text-sm font-semibold">Disciplinary History</p>   <button
          @click="showCreateDisciplinary = true"
          class="bg-primary text-white rounded-full px-3 py-1 text-sm"
          v-if="getUserType.toLowerCase()==='hr manager'"
      >
        Create Record
      </button>
      </div>
      <div class="relative">
        <transition name="fade">
          <div
              v-if="loading"
              class="inset-0 absolute z-50 bg-black bg-opacity-10 w-full"
          >
            <loader class="center-h-v" />
          </div>
        </transition>
        <transition name="fade">
          <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>

        <div class="">
          <div v-if="tableData.length===0">
            <p class="text-center">No records found</p>
          </div>
          <template v-if="tableData.length > 0">
            <el-collapse accordion>
              <el-collapse-item
                  v-for="(row, index) in tableData"
                  :key="row.Subject +  index"
                  :name="row.Subject + index"
                  class="mt-3">
                <template #title>
                 <div class="flex justify-between w-full">
                   <h1 class="font-semibold capitalize">
                     {{ row.Subject }}  <span class="text-sm font-light text-gray-400"> ({{ row.DisciplinaryType }})</span>
                   </h1>

                 </div>
                </template>
                <div class="p-2 text-gray-700 text-sm">
                  <p v-html="row.Comments"></p>
                </div>
              </el-collapse-item>
            </el-collapse>
          </template>


          <!-- Pagination -->
<!--          <div class="table-pagination text-center mt-2">
            <el-pagination
                v-if="tableData?.length > 0"
                background
                layout="prev, pager, next"
                :total="totalCount"
                :page-size="pageSize"
                @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import createDisciplinaryRecord from "../modals/createDisciplinaryRecord"
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "Disciplinary",
  components: {
    Loader,
    createDisciplinaryRecord
  },
  data() {
    return {
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      showCreateDisciplinary:false,
      success: null,
      create_success: null,
      loading: false,
      reload: false,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Subject",
          key: "Subject",
          title: "Subject",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
              <div
                  class="cursor-pointer text-blue-500"

              >
                {row.Subject}
              </div>
          ),
        },
        {
          field: "Type",
          key: "Type",
          title: "Type",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
              <p class="text-left">{row.DisciplinaryType}</p>
          ),
        },

        {
          field: "Comments",
          key: "comments",
          title: "Comments",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
              <p class="text-left">{row.Comments}</p>
          ),
        },


      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getUserType",
      "getCurrentEmployeeId",
    ]),

    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.currentTableData;
      } else {
        // Filter the currentTableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
                item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
          (pageIndex - 1) * pageSize,
          pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getMyDisciplinaryRecord();
  },

  methods: {
    close() {
      this.showCreateDisciplinary = false;
      this.getMyDisciplinaryRecord();
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },

    handleCloseOnSuccess() {
      this.showCreateDisciplinary = false;
      this.success = true;
      setTimeout(() => {
        this.success = false;
        this. getMyDisciplinaryRecord();
      }, 3000);
    },

    formatDate(dateStr) {
      return moment(dateStr).format("DD/MM/YYYY");
    },

    getMyDisciplinaryRecord() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
        params: {
          employeeID: this.getCurrentEmployeeId,
        },
      };

      axios
          .get(
              `${this.getOrganization}/employee/disciplinary/history/${this.$ApiVersion}/request`,
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.status == 200) {
                  this.tableData = response.data.Data;
                } else {
                  this.create_error = response.data.StatusMessage;
                }
              },
              (error) => {
                this.loading = false;
                this.create_error = error.message;
              }
          );
    },
  },
};
</script>

<style>
.el-tabs__item.is-top.is-active {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: "#fff" !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #fff;
}

.el-tabs--border-card
> .el-tabs__header
.el-tabs__item:not(.is-disabled):hover {
  color: #fff;
}

.el-tabs__item.is-top:hover {
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
}
</style>
